import axios from "axios";
import {getBaseUrl, getCompanyId, getToken} from "../../Auth";
import moment from "moment";
import {getOffset} from "../../components/TimeFormat";
import {engine, getAppInformation} from "../../Utilities/index";

const CancelToken = axios.CancelToken;
let canceler;

const API = {
    current: undefined,

    call(params, endpoint = '/api/lazy/manage/data') {
        API.current = engine().post(
            endpoint,
            params,
            {
                cancelToken: new CancelToken(function executor(c){
                    canceler = c;
                })
            }
        ).finally(
            () => API.current = undefined
        );

        return API.current;
    },

    cancel() {
        if ( API.current )
            return canceler();
        else
            return false;
    },

    fetchSummary: (date,station) => {
        return API.call({
            actions: {
                response: {
                    dailyDriverSummary:{
                        findOneBy: {
                            get: "summary",
                            criteria: {
                                company: getCompanyId(),
                                summaryDate:date,
                                station:station
                            },
                            excludes: {
                                0: "company",
                                1: "skill"
                            },
                            includes: {
                                "0": "id",
                                "1": "summary",
                                "2" : "driversHired",
                                "3" : "driversFired",
                                "4" : "driversQuit",
                                "5" : "scheduledInterviews",
                                "6" : "interviewsCompleted",
                                "7": "reportUrl",
                                "lockByUser": ["id","friendlyName"],
                                "station": ["id","code"],
                                "modifiedBy": ["id","friendlyName"],
                                "updated":"updatedDate"
                            }
                        }
                    }
                }
            }
        });
    },

    addSummary: (summary) => {
        summary.company = getCompanyId();
        summary.createdDate = moment().format();
        summary.updatedDate = summary.createdDate;
        return API.call({
            actions: {
                create: {
                    dailyDriverSummary:{
                        summary1: summary
                    }
                }
            }
        });
    },
    updateSummary: (summary) => {
        const ID = summary.id;
        delete summary.id;
        return API.call({
            actions: {
                update: {
                    dailyDriverSummary:{
                        summary1: {
                            findBy: {
                                id: ID
                            },
                            updateRecord: summary
                        }
                    }
                }
            }
        });
    },
    narrativeLockPayload: (functionName, get, criteria) => ({
        actions: {
            response: {
                DailyDriverSummary:{
                    custom: {
                        functionName: functionName,
                        get: get,
                        criteria: {
                            company: getCompanyId(),
                            serialize: false,
                            ...criteria
                        }
                    }
                }
            }
        }
    }),
    narrativeLockCall: (functionName, get, criteria) => {
        return API.call(API.narrativeLockPayload(functionName, get, criteria));
    },

    releaseLockOnUnload: (summaryId, station) => {
        fetch(getBaseUrl() + '/api/lazy/manage/data', {
            method: 'POST',
            keepalive: true,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify({
                ...API.narrativeLockPayload('releaseSummaryLock', 'release', {summaryId, station, fields: null}),
                appInformation: getAppInformation()
            })
        }).catch(() => {});
    },
    acquireLock: (date, station) => {
        return API.narrativeLockCall('acquireSummaryLock', 'lock', {date, station});
    },
    releaseLock: (summaryId, station, fields = null) => {
        return API.narrativeLockCall('releaseSummaryLock', 'release', {summaryId, station, fields});
    },
    saveNarrative: (summaryId, station, fields) => {
        return API.narrativeLockCall('saveSummaryNarrative', 'save', {summaryId, station, fields});
    },
    broadcastDraft: (summaryId, station, fields) => {
        return API.narrativeLockCall('broadcastSummaryDraft', 'draft', {summaryId, station, fields});
    },
    generateSummary: (params) => {
        return API.call({
            actions: {
                response: {
                    DailyDriverSummary:{
                        custom: {
                            functionName: "createDailySummaryNarrativeReport",
                            get: "dailySummary",
                            criteria: {
                                date : params['currentDate'],
                                station : params['currentStation'],
                                isNightlyReport : false
                            }
                        }
                    }
                }
            }
        });
    },
    dailySummaryDownload: (params) => {
        return API.call({
            actions: {
                response: {
                    DailyDriverSummary:{
                        custom: {
                            functionName: "dailySummaryDownload",
                            get: "pdf",
                            criteria: {
                                company: getCompanyId(),
                                date:params['currentDate'],
                                station:params['currentStation']
                            }
                        }
                    }
                }
            }
        });
    }
}

export default API;